<template>
  <div>
    <ul style="max-height: 290px;overflow-y:auto;">
      <li v-for="address in addressList">
        <i v-if="!noNeedEdit" class="ico ico-edit float-right pointer edit" @click="edit(address)"></i>
        <CheckboxItem v-on:changeItem="changeItem" :item="address" :active="addressInfo.address_id">
          <SingleAddress class="address-info" :address="address"></SingleAddress>
        </CheckboxItem>
      </li>
    </ul>
    <el-button style="margin: 40px 0;" class="block" type="primary" @click="submit()" :loading="loading">确定</el-button>
  </div>
</template>

<script>
import SingleAddress from './SingleAddress'
import CheckboxItem from '../../../components/CheckboxItem'
import api from '../../../services/api.js'
let _ = require('lodash')

export default {
  name: 'AddressList',
  props: ['addressId','support_transport_service','noNeedEdit'],
  components: {
    CheckboxItem: CheckboxItem,
    SingleAddress: SingleAddress
  },
  computed: {
    taskInfo () {
	    return this.$store.state.taskInfo
    }
  },
  created () {
    this.getAddressList()
    this.addressInfo.address_id = this.addressId || this.taskInfo.address_id
  },
  data () {
    return {
      addressList: null,
      addressInfo: {
        address_id: null,
        address_info: null
      }
    }
  },
  methods: {
    async getAddressList () {
      let res = await api.getAddressList(this)
      this.addressList = res.body.result
      if(this.support_transport_service == '2') {
        let addressList = []
        _.each(this.addressList, item => {
          if(item.country == '中国香港(HK)' || item.country == '中国大陆(CN)') {
            addressList.push(item)
          }
        })
        this.addressList = addressList
      }
    },
    changeItem (data) {
      this.addressInfo.address_id = data.item.id
      this.addressInfo.address_info = data.item
    },
    submit () {
      this.$emit('changeAddress', this.addressInfo)
    },
    edit (address) {
      this.$emit('editAddress', address)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.address-info {
  padding: 5px 15px;
}
.edit {
  margin: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/address/AddressList.vue